<table class="calc-vals">
    <thead>
        <tr>
            <th>Total</th>
            <th>Avg</th>
            <th>Min</th>
            <th>Max</th>
            <th>Count</th>
        </tr>
    </thead>
    <tr>
        <td>{{ total | number: '1.0-3' }}</td>
        <td>{{ average | number: '1.0-3' }}</td>
        <td>{{ min | number: '1.0-3' }}</td>
        <td>{{ max | number: '1.0-3' }}</td>
        <td>{{ count | number: '1.0-0' }}</td>
    </tr>
</table>
